module.exports = __webpack_public_path__ + "static/img/7-info.13174af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/7-info.png
// module id = w5TQ
// module chunks = 0